import client from "../client";

export const authApi = {
    async login({ email, password }) {
        const { data } = await client.post("/auth/login", { email, password });
        return data;
    },
    async refresh(refreshToken) {
        const { data } = await client.post("/auth/refresh", { refreshToken });
        return data;
    },
    async me() {
        const { data } = await client.get("/auth/me");
        return data;
    },
};
